import './EventTime.css'
import { useDraggable } from '@dnd-kit/core';
import {CSS} from '@dnd-kit/utilities';
import { Event } from '../../models/calendar/Event.model';
import { useModalEvent } from '../../contexts/calendar/ModalEventContext.context';
import { useCalendar } from '../../contexts/calendar/CalendarContext.context';

import clsx from 'clsx';
import { getColorByUid } from '../../utils/colorUtils';
type Props = {
    event:Event
    isDay:Boolean
}

const formatEventDate = (startDate: string, duration: number, endDate?: string) => {
    const date = new Date(startDate);
    if (isNaN(date.getTime())) return '';

    const optionsTime: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };
    const startTime = date.toLocaleTimeString('es-ES', optionsTime).replace(/\s/g, '').replaceAll('.','');

    // Prefer the explicit end field; fall back to duration calculation
    let end: Date | null = null;
    if (endDate) {
        const parsed = new Date(endDate);
        if (!isNaN(parsed.getTime())) end = parsed;
    }
    if (!end && duration && !isNaN(duration) && duration > 0) {
        end = new Date(date.getTime() + duration * 60000);
    }

    if (!end) return startTime;
    const endTime = end.toLocaleTimeString('es-ES', optionsTime).replace(/\s/g, '').replaceAll('.','');
    return `${startTime}–${endTime}`;
};

export const EventTime = ({ event,isDay }: Props) => {
    //const [isEditing,setIsEditing] = useState<boolean>(false);
    //const [isOpen, setIsOpen] = useState(false);
    const {calendar} = useCalendar();
    //console.error("calendariuo",calendar.color,calendar.uid)
    const {attributes, listeners, setNodeRef,transform} = useDraggable({
        id: event.id,
    });
    const style: React.CSSProperties = {
        /*position: 'absolute',*/
        /*zIndex: 20,
        width: '200px',*/
        transform: CSS.Translate.toString(transform) || undefined,
    };
    const {setOptions} = useModalEvent();
    const handleClickDay = () =>{
        //console.log("evento ",event)
        const date = new Date(event.start);
        setOptions((prev)=>({
            ...prev,
            isopen:true,
            numberOfWeek:date.getDay(),
            day:date.getDate(),
            month:date.getMonth(),
            year:date.getFullYear(),
            id:event.id,
            isCreating:false,
            isEditing:false,
            isViewing:true
        }))
    }
    const eventColor = getColorByUid(event.responsibleId || event.createdBy) || calendar.color || "#3b82f6";

    return(
        <div className="time-range-event" ref={setNodeRef} onClick={handleClickDay}
            title={`${event.summary}\n${formatEventDate(event.start, event.duration, event.end)}`}
            style={{ "--time-range-color": eventColor } as React.CSSProperties} >
            <div className="time-range" style={style} {...listeners} {...attributes}>
                {event.summary && 
                    <div className={clsx(
                        "event-title",
                        {
                            "container": isDay,
                            "month": !isDay
                        })}>
                        <span className={isDay?"first":""}>{formatEventDate(event.start, event.duration, event.end)} </span>
                        <span className={isDay?"second":""}>{
                            event.summary[0].toUpperCase()+event.summary.substring(1,event.summary.length).toLowerCase()
                        }</span>
                    </div>
                }
            </div>
        </div>
    )
};
